<template>

    <section class="col-md-3" >
        <p class="h6 facet-title hidden-sm-down" :data-id="parentFilter.id">{{ parentFilter.name }}</p>
        <div class="form-check"
             v-for="item in parentFilter.values">
            <input class="form-check-input" type="checkbox"
                   :id="getUniqueId(item)"
                   :data-id="getId(item)"
                   :data-idparent="parentFilter.id"
                   :value="getName(item)"
                   @input="toggleCheckbox"
            >
            <label class="form-check-label" :for="getUniqueId(item)">
                {{getName(item)}}
            </label>
        </div>
    </section>
</template>


<script>
    import {mapActions, mapGetters} from 'vuex';
    import * as types from '../store/types';
    import * as type from '../api/type';

    export default {
        name: 'FilterValue',
        data() {
            return {
            }
        },
        props: {
            parentFilter: Object,
            type: String,
        },
        methods: {
            getName(item){
                if(this.type === type.getTypeFilterFeature()){
                    return item.value;
                }
                return item.name;
            },
            getId(item){
                if(this.type === type.getTypeFilterFeature()){
                    return parseInt(item.id_feature_value);
                }
                return item.id_attribute;
            },
            getUniqueId(item){
                return this.type + '_' + this.getId(item);
            },
            ...mapActions({
                toggleFilter: types.TOGGLE_FILTER
            }),
            ...mapGetters({
                getValuesAttribute: types.GET_VALUES_ATTRIBUTES,
                getValuesFeature: types.GET_VALUE_FEATURES
            }),
            toggleCheckbox(item) {
                const target = item.target;
                this.$store.dispatch(types.TOGGLE_FILTER, {id : target.dataset.id, idParent : this.parentFilter.id, type : this.type})
            }
        }
    }
</script>


<style>

    .form-check {
        text-align: left;
    }

</style>


// WEBPACK FOOTER //
// src/components/FilterValue.vue